import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function MechanismReveal() {
  return <section className="py-20 px-6 bg-cream" data-id="element-72">
      <div className="max-w-3xl mx-auto text-center" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-74">
          <p className="text-warm-gray font-medium tracking-widest uppercase mb-4 text-sm" data-id="element-75">
            Presentando
          </p>
          <h2 className="text-3xl md:text-5xl font-serif text-charcoal mb-12" data-id="element-76">
            La LÍNEA SEGURO‑PARA‑GASTAR
          </h2>

          <div className="grid md:grid-cols-3 gap-6 mb-16 text-sm md:text-base text-warm-gray" data-id="element-77">
            <div className="flex flex-col items-center" data-id="element-78">
              <span className="text-warm-red text-2xl mb-2" data-id="element-79">✕</span>
              <p data-id="element-80">No es una app</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-81">
              <span className="text-warm-red text-2xl mb-2" data-id="element-82">✕</span>
              <p data-id="element-83">No es un presupuesto de 12 pestañas</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-84">
              <span className="text-warm-red text-2xl mb-2" data-id="element-85">✕</span>
              <p data-id="element-86">No es "anota cada centavo"</p>
            </div>
          </div>

          {/* The Formula Card */}
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-warm-gray/10 relative overflow-hidden" data-id="element-87">
            <div className="absolute top-0 left-0 w-full h-2 bg-forest" data-id="element-88"></div>

            <p className="text-lg text-charcoal mb-8" data-id="element-89">
              Es un cálculo simple que haces el día de pago:
            </p>

            <div className="space-y-4 text-left max-w-md mx-auto font-medium text-lg md:text-xl" data-id="element-90">
              <div className="flex justify-between items-center text-forest" data-id="element-91">
                <span data-id="element-92">Pago neto</span>
                <span data-id="element-93">(+)</span>
              </div>
              <div className="flex justify-between items-center text-warm-red" data-id="element-94">
                <span data-id="element-95">Fijos (antes del próx. pago)</span>
                <span data-id="element-96">(−)</span>
              </div>
              <div className="flex justify-between items-center text-warm-red" data-id="element-97">
                <span data-id="element-98">Esenciales protegidos (comida, gas, niños)</span>
                <span data-id="element-99">(−)</span>
              </div>
              <div className="flex justify-between items-center text-warm-red" data-id="element-100">
                <span data-id="element-101">Buffer NO TOCAR</span>
                <span data-id="element-102">(−)</span>
              </div>

              <div className="h-px bg-charcoal/20 my-4" data-id="element-103"></div>

              <div className="flex justify-between items-center font-serif text-2xl md:text-3xl text-charcoal pt-2" data-id="element-104">
                <span data-id="element-105">Tu número SEGURO</span>
                <span data-id="element-106">=</span>
              </div>
            </div>
          </div>

          <div className="mt-12 space-y-4 mb-12" data-id="element-107">
            <p className="text-xl text-charcoal" data-id="element-108">
              Ese número se convierte en tu "cap" semanal.
            </p>
            <p className="text-xl text-charcoal" data-id="element-109">Tu semáforo.</p>
            <p className="text-2xl font-serif text-forest" data-id="element-110">Tu paz.</p>
          </div>

          <div className="mt-8" data-id="element-111">
            <Button scrollTo="checkout" data-id="element-112">Quiero mi número SEGURO — $6.36</Button>
            <p className="mt-3 text-sm text-warm-gray" data-id="element-113">Descarga inmediata</p>
          </div>
        </motion.div>
      </div>
    </section>;
}